import { createFileRoute } from "@tanstack/react-router";
import { Agents } from "@/components/Agents";

function RouteComponent() {
  return <Agents />;
}

export const Route = createFileRoute("/_authenticated/agents/")({
  component: RouteComponent,
  staticData: { page: "engineering" },
});
